import { useMutation } from "@tanstack/react-query"
import axios, { AxiosProgressEvent } from "axios"

import { useRegistrationData } from "../details/use-registration-data"

import { PdfUploadFieldValue } from "types"

interface UploadPdfParams {
  file: File
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
}

export const useUploadPdfMutation = () => {
  const { guideId } = useRegistrationData()

  return useMutation<PdfUploadFieldValue, Error, UploadPdfParams>({
    mutationFn: async ({ file, onUploadProgress }) => {
      if (!guideId) {
        throw new Error("Guide ID is required for PDF upload")
      }

      const formData = new FormData()
      formData.append("file", file)
      formData.append("guide", guideId.toString())
      formData.append("filename", file.name)

      const response = await axios.post<PdfUploadFieldValue>(
        "/api/survey-pdfs/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress,
        }
      )

      if (!response.data || !response.data.id || !response.data.presigned_url) {
        throw new Error("Invalid response from server")
      }

      return response.data
    },
  })
}